import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
// const STUDENT = 'student'
const STUDENT = 'student'
const REPORTER = 'reporter'
const CATEGORY = 'condition_category'
const CONDITION = 'condition'
const DESCRIPTION = 'description'

/**
 * Form model
 */
const formModel = () => {
  return {
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
      required: true,
    },
    [REPORTER]: {
      label: `${t('common.reporter')}`,
      name: REPORTER,
      required: true,
    },
    [CATEGORY]: {
      label: `${t('common.condition-category')}`,
      name: CATEGORY,
    },
    [CONDITION]: {
      label: `${t('common.condition')}`,
      name: CONDITION,
      required: true,
    },
    [DESCRIPTION]: {
      label: `${t('common.description')}`,
      name: DESCRIPTION,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [STUDENT]: '',
  [REPORTER]: '',
  [CATEGORY]: '',
  [CONDITION]: '',
  [DESCRIPTION]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [STUDENT]: yup
    .object()
    .shape({
      title: yup
        .string()
        .nullable()
        .required(`${t('required-error-message')}`),
    })
    .nullable()
    .required(`${t('errors.required-error-message')}`),
    [CATEGORY]: yup
    .object()
    .shape({
      title: yup
        .string()
        .nullable()
    })
    .nullable(),
    [CONDITION]: yup
    .object()
    .shape({
      title: yup
        .string()
        .nullable()
        .required(`${t('required-error-message')}`),
    })
    .nullable()
    .required(`${t('errors.required-error-message')}`),
    [DESCRIPTION]: yup
      .string()
      .nullable()
  })

export default formModel
